import { render, staticRenderFns } from "./PersonnelGeneralTable.vue?vue&type=template&id=52fba346"
import script from "./PersonnelGeneralTable.vue?vue&type=script&lang=js"
export * from "./PersonnelGeneralTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports